'use strict'

import * as types from './types';

export const findAddress = query => ({
	type: types.SEARCH_ADDRESS,
	meta: {
		async: true,
		endPoint: `/locations/search`,
		method: 'GET',
		params: {
			query,
		},
	},
});
